import styles from "./project.module.scss";
import amauriFreela from "../../../assets/amauri-freela.png";
import { useState } from "react";

const projects = [
  {
    title: "Amauri Holanda - Freelance",
    type: "Freelance",
    year: "2026",
    icon: "",
    description:
      "Desenvolvimento de um portfólio acadêmico e profissional para o professor Amauri Holanda, apresentando sua trajetória, áreas de pesquisa, publicações e informações sobre os integrantes do laboratório. A plataforma também centraliza seus principais canais acadêmicos e profissionais, como currículo, Google Scholar, e-mail e perfil no X (antigo Twitter).",
    stack: ["React", "TypeScript", "Sass"],
    liveUrl: "https://amauriholanda.org/",
    codeUrl: null,
    featured: true,
  },
  {
    title: "Reservaê",
    type: "Frontend",
    year: "2026",
    description:
      "Projeto desenvolvido durante o Hackathon da Coda.ce 2026, vencedor da competição. A aplicação conecta usuários a arenas esportivas, facilitando a busca, organização e reserva de quadras para modalidades como Beach Tennis, Vôlei e Futevôlei.",
    stack: ["React.js", "Sass", "TypeScript"],
    liveUrl: "https://reservae.jlab.app.br/onboarding",
    codeUrl: null,
    featured: false,
  },
  {
    title: "Luscent",
    type: "Frontend",
    year: "2026",
    description:
      "Desenvolvimento de uma aplicação web para uma empresa internacional, atuando na implementação de interfaces e funcionalidades frontend.",
    stack: ["React.js", "Tailwind", "Storybook", "GraphQL"],
    liveUrl: null,
    codeUrl: null,
    featured: false,
  },
  // {
  //   title: "NodeJs Backend",
  //   type: "Backend",
  //   year: "2026",
  //   description: "Projeto básico para estudo de backend com NodeJs",
  //   stack: ["Node.js"],
  //   liveUrl: null,
  //   codeUrl: "https://github.com/matheustsx/nodejs-backend",
  //   featured: false,
  // },
];

export const Project = () => {
  const [featured, ...others] = projects;
  const [expanded, setExpanded] = useState(false);

  return (
    <section id="projetos" className={styles["container"]}>
      <div className={styles["inner"]}>
        <div className={styles["head"]}>
          <div className={styles["head-text"]}>
            <span className={styles["label"]}>03 — Projetos</span>
            <h2 className={styles["title"]}>Trabalhos selecionados</h2>
          </div>
        </div>

        <article className={`${styles["card"]} ${styles["featured"]}`}>
          <div className={styles["featured-content"]}>
            <span className={styles["badge"]}>Destaque</span>
            <div className={styles["card-head"]}>
              <span className={styles["card-type"]}>{featured.type}</span>
              <span className={styles["card-year"]}>{featured.year}</span>
            </div>
            <h3 className={styles["card-title"]}>{featured.title}</h3>
            <p className={styles["card-description"]}>{featured.description}</p>
            <ul className={styles["stack"]}>
              {featured.stack.map((tech) => (
                <li key={tech}>{tech}</li>
              ))}
            </ul>
            <div className={styles["links"]}>
              {featured.liveUrl && (
                <a
                  href={featured.liveUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles["link"]}
                >
                  Ver projeto
                </a>
              )}
            </div>
          </div>
          <div className={styles["featured-preview"]}>
            <div className={styles["preview-bar"]}>
              <i />
              <i />
              <i />
            </div>
            <div className={styles["preview-body"]}>
              <img
                src={amauriFreela}
                alt="descrição"
                onClick={() => setExpanded(true)}
              />
              {expanded && (
                <div
                  className={styles["overlay"]}
                  onClick={() => setExpanded(false)}
                >
                  <img
                    src={amauriFreela}
                    alt="descrição"
                    className={styles["expanded"]}
                  />
                </div>
              )}
            </div>
          </div>
        </article>

        <div className={styles["grid"]}>
          {others.map((project) => (
            <article key={project.title} className={styles["card"]}>
              <div className={styles["card-head"]}>
                <span className={styles["card-type"]}>{project.type}</span>
                <span className={styles["card-year"]}>{project.year}</span>
              </div>
              <h3 className={styles["card-title"]}>{project.title}</h3>
              <p className={styles["card-description"]}>
                {project.description}
              </p>
              <ul className={styles["stack"]}>
                {project.stack.map((tech) => (
                  <li key={tech}>{tech}</li>
                ))}
              </ul>
              <div className={styles["links"]}>
                {project.liveUrl && (
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["link"]}
                  >
                    Ver projeto
                  </a>
                )}

                {project.codeUrl && (
                  <a
                    href={project.codeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles["link"]}
                  >
                    Ver código
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Project;
